import type { JSX } from 'react';

import { useNotificationCenterContext } from './NotificationCenterLayout';
import ActivitySection from './activity/ActivitySection';

const NotificationCenterActivityPage = (): JSX.Element => {
  const { masterProject } = useNotificationCenterContext();

  return <ActivitySection key={masterProject.id} masterProjectId={masterProject.id} />;
};

export default NotificationCenterActivityPage;
